<template>
  <main class="container my-5">

    <div style="margin-bottom: 200px" v-if="!loading" v-html="pagina"></div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
//import pagina from url;
export default {
  name: "Pagina",
  components: { Loading },
  data() {
    return {
      pagina: "",
      loading: true
    };
  },
  created() {
    this.obterPagina(this.$route.params.pagina);
  },
  watch: {
    "$route.params.pagina": function (str) {
      if (str !== this.pagina) this.obterPagina(str);
    }
  },
  methods: {
    obterPagina() {
      this.loading = true;
      window.scrollTo(0, 0);
      this.pagina = `<div class="d-flex justify-content-center"> <div class="spinner-border spinner-grow" style="width: 3rem; height: 3rem;"></div></div>`;
      axios
        .get(`paginas/${window.APP_ORIGIN}/${this.$route.params.pagina}.html`)
        .then(response => {
          this.pagina = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.pagina = `<div class="align-items-center d-flex flex-column py-5"><img src="https://pagglo-cdn.s3.amazonaws.com/marketplace/em_contrucao.png" alt="Página em construção" height="50" style="height: 150px;"><h3>Página em construção</h3></div>`;
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss"></style>
